import React, { useEffect, useState } from "react";

export const ContactUsPage: React.FunctionComponent = () => {
  return (
    <div>
      <div>email: cookiemonster@sweamers.com</div>
    </div>
  );
};
